module.exports = __webpack_public_path__ + "static/img/vouchers405.43d0b97d.png";